import { CreditCardOutlined } from '@ant-design/icons';
import { ModuleDefinition } from '../types';
import { createNavItem } from '@/utils/navigation';

// Module translations
import en from './locales/en.json';
import de from './locales/de.json';
import bg from './locales/bg.json';

/**
 * Payment Module
 *
 * Manages payments and payment processing from the external Payment system.
 * Provides functionality to view payments, process transactions, and manage payment methods.
 */

// Module configuration constants
const MODULE_NAME = 'paymentModule';
const ROUTE_NAMESPACE = 'manage' as const;

/**
 * Base route path for this module
 * Use this constant throughout the module to avoid duplication
 */
export const MODULE_BASE_ROUTE = `/${ROUTE_NAMESPACE}/modules/${MODULE_NAME}`;

export const module: ModuleDefinition = {
  id: 'payment-module',
  name: 'Payment Module',
  version: '1.0.0',
  description: 'Manage payments and payment processing from the external Payment system',
  author: 'System',
  category: 'business',

  // Route namespace - determines where module routes are mounted
  routeNamespace: ROUTE_NAMESPACE,

  // Global roles required
  requiredRoles: ['USER', 'ADMIN'],

  // Tenant roles required
  requiredTenantRoles: ['OWNER', 'EMPLOYEE'],
  useServerRelay: true,

  // Navigation items to add
  navigationItems: [createNavItem('ext-payments', <CreditCardOutlined />, 'CMS 4 Payments Module', MODULE_BASE_ROUTE, false)],

  // Configuration schema
  configSchema: {
    type: 'object',
    properties: {
      apiUrl: {
        type: 'string',
        description: 'The base URL for the Payment API endpoint',
        required: true,
        serverOnly: true,
      },
      apiToken: {
        type: 'string',
        description: 'The API token for the Payment API endpoint',
        required: true,
        serverOnly: true,
      },
      notificationWebhook: {
        type: 'string',
        description: 'Webhook URL to notify when a payment link is created and email notification is enabled',
        required: false,
      },
      paymentWebhook: {
        type: 'string',
        description: 'Webhook URL to be sent to the external system to notify about payment status changes',
        required: false,
      }
    }
  },

  // Module translations (registered as i18n namespace 'payment-module')
  translations: { en, de, bg },

  // Lifecycle hooks
  onLoad: async () => {
    console.log('Payment Module loaded');
  },
};

// Export as default
export default module;
